import lift from '@tcc/load-lifter';
import { setActiveOperationUuid } from 'current';
import { errorLevel } from 'constants/errors';
import { treatErrorAs } from 'api/errors';
import { isFieldsFromOlEnabled } from 'user/selectors';
import { findFieldsByOperations } from 'fields/finders';
import { getAllOperationUuids } from 'operations/selectors';
import { farmerNavigationDefaultOperation } from 'constants/operations';

// TODO: This file should move to init/

const addDataManagerHandler = () => {
  // This is attached to the navigation bar, so no need to manage this outgoing
  // link.
  document.querySelectorAll('a[href*="/static/nitrogen-mass-data-web"]').forEach((node) => {
    if(node.href.indexOf('?') > -1) {
      node.href += '&starting-view=planting';
    } else {
      node.href += '?starting-view=planting';
    }
  });
};

export const installNavBar = ({ dispatch, getState }) => {
  const body = document.querySelector('body');
  if(!body.classList.contains('tccNavIsUnloaded')) {
    return;
  }

  body.classList.remove('tccNavIsUnloaded');
  // HAHAHAHAHAHAHAHAHAHAHA. sob. crate is using svg-sprite-loader, which
  // doesn't seem to check if the sprite sheet is already in the body, so will
  // happily append a 2nd sprite sheet, which seems to break the first one
  // script-creator is loading with crate, somehow.
  Promise.resolve()
  .then( () => {
    return lift(['farmer-navigation'], (nav) => {
      const svg = document.querySelectorAll('body > svg');
      if (svg.length > 1) {
        document.querySelector('body').removeChild(svg[0]);
      }
      nav.install(document.getElementById('navigation'));
      const eventEmitter = nav.getEventEmitter();
      eventEmitter.on('change:operation', async (operationUuid) => {
        const state = getState();
        if (isFieldsFromOlEnabled(state)) {
          const operationsIds = operationUuid === farmerNavigationDefaultOperation
            ? getAllOperationUuids(state)
            : [operationUuid];

          await findFieldsByOperations({ dispatch, getState, operationsIds });
        }

        dispatch(setActiveOperationUuid(operationUuid));
      });
    });
  })
  .then(() => {
    addDataManagerHandler();
  })
  .catch( treatErrorAs({ severity: errorLevel.WARN, andHandleNow: true}) );
};
